module.exports = __webpack_public_path__ + "static/media/206-footer-image-color.84d49707.jpg";